import styles from "./Tags.module.css";
import {IoCloseSharp} from "react-icons/io5";

interface Tag {
  name: string;
  onClick: () => void;
}

export default function Tags({name, onClick} : Tag) {
    return (
      <div className={styles.tag}>
        <p>{name}</p>
        <IoCloseSharp size={22} className={styles.close} onClick={() => onClick()}/>
      </div>
    );
}